var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H0V22H0.02L0 40C0 42.2 1.8 44 4 44H40V40H4V12ZM14 30H42L35 21L30 27.02L23 18L14 30ZM44 8H28L24 4H12C9.8 4 8.02 5.8 8.02 8L8 32C8 34.2 9.8 36 12 36H44C46.2 36 48 34.2 48 32V12C48 9.8 46.2 8 44 8ZM44 32H12V8H22.34L26.34 12H44V32Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.5e3e85076582e79f2035e4d951eb91c7.svg";
export { ForwardRef as ReactComponent };